export const appViews = {
  // ── VideoGuides.vue ──
  guides: {
    openCenter: "Ouvrir le centre de guides",
    fabLabel: "Guides",
    assistantAria: "Assistant de guides",
    dontShowAgain: "Ne plus afficher",
    centerAria: "Centre de guides",
    eyebrow: "CENTRE DE GUIDES",
    title: "Découvrez WACheckin",
    watchedOf: "{watched} sur {total} visionnés",
    close: "Fermer",
    searchPlaceholder: "Rechercher un guide…",
    forThisScreen: "Pour cet écran",
    watched: "Visionné",
    watchGuide: "Voir le guide",
    comingSoon: "Bientôt disponible : nouvelles améliorations et mises à jour.",
    noResults: "Aucun résultat pour « {query} ».",
    needHelp: "Besoin d'aide ? ",
    contactWhatsApp: "Écrivez-nous sur WhatsApp",
    lightboxMeta: "{section} · Guide {n} sur {total}",
    videoTitle: "Vidéo du guide",
    playerAria: "Lecteur de guides",
    prev: "Précédent",
    watchOnYouTube: "Regarder sur YouTube",
    next: "Suivant",
    sections: {
      inicio: "Pour commencer",
      alojamiento: "Votre logement",
      tarifas: "Tarifs et canaux",
      calendario: "Calendrier et réservations",
      huesped: "Expérience voyageur",
      autoridades: "Autorités",
      novedades: "Nouveautés",
    },
    videos: {
      navigate: "Accéder aux réglages et y naviguer",
      propertyData: "Les informations, l'emplacement et l'identité visuelle de votre logement",
      checkinWelcome: "Enregistrement, message de bienvenue et politiques",
      basePrices: "Prix de base et tarifs dérivés par canal",
      calendar: "Calendrier : réservations, disponibilités et prix",
      guestJourney: "Le parcours du voyageur : messages, codes et automatisations",
      guestVerification: "Vérification du voyageur et demandes d'avis",
      authorities: "Connecter les autorités et envoyer les rapports de voyageurs",
    },
    ai: {
      cta: "Voir la liste des vidéos",
      assistant: "Assistant",
      inicio: "Premier jour ici ? Laissez-moi vous montrer les bases en 2 minutes.",
      alojamiento: "Vous configurez votre logement ? Découvrez comment le régler parfaitement.",
      tarifas: "Des questions sur les prix ? Laissez-moi vous expliquer les tarifs par canal.",
      calendario: "Envie de maîtriser le calendrier ? Réservations, prix et disponibilités.",
      huesped: "On automatise le parcours du voyageur ? Je vous montre étape par étape.",
      autoridades: "On connecte les autorités ? Envoyez les rapports de voyageurs en 1 vidéo.",
    },
  },
  // ── NovedadesDrawer.vue ──
  news: {
    ariaPanel: "Actualités du système",
    latestUpdates: "Dernières mises à jour",
    close: "Fermer",
    tabNews: "Nouveautés",
    reports: "Signalements",
    loading: "Chargement…",
    emptyNews: "Aucune actualité pour le moment. Vous verrez les améliorations ici dès que nous les publierons.",
    showMore: "Afficher plus",
    showLess: "Afficher moins",
    reportProblem: "Signaler un problème",
    emptyReports: "Vous n'avez encore envoyé aucun signalement.",
    sendReport: "+ Envoyer un signalement",
    sendNewReport: "+ Envoyer un nouveau signalement",
    capturesCount: "{count} capture d'écran | {count} captures d'écran",
    viewConversation: "Voir la conversation →",
    new: "Nouveau",
    openedOn: "ouvert le {date}",
    conversationWithSupport: "Conversation avec l'équipe d'assistance",
    you: "Vous",
    support: "Assistance",
    noReplyYet: "Personne de l'équipe n'a encore répondu. Nous vous préviendrons ici dès que ce sera le cas.",
    replyPlaceholder: "Écrivez votre réponse…",
    send: "Envoyer",
    replyHint: "<b>Entrée</b> pour envoyer · <b>Maj + Entrée</b> pour un saut de ligne",
    back: "Retour",
    sendReportTitle: "Envoyer un signalement",
    formSubtitle: "Dites-nous ce qui s'est passé et nous examinerons cela. Vous verrez la réponse dans vos signalements.",
    about: "Concernant",
    whatHappens: "Que se passe-t-il ?",
    titlePlaceholder: "Résumez en une phrase",
    describeDetail: "Décrivez-le en détail",
    descPlaceholder: "Ce que vous attendiez, ce qui s'est passé et comment le reproduire.",
    capture: "Capture d'écran",
    optional: "facultatif",
    attachHint: "Appuyez pour joindre une image",
    sending: "Envoi…",
    submitReport: "Envoyer le signalement",
    prev: "Précédent",
    next: "Suivant",
    today: "Aujourd'hui",
    yesterday: "Hier",
    status: {
      open: "Ouvert",
      in_progress: "En cours",
      resolved: "Résolu",
      closed: "Fermé",
    },
    errRequired: "Dites-nous ce qui se passe.",
    errSend: "Envoi impossible. Veuillez réessayer.",
  },
  // ── VerifyIdentity.vue ──
  verify: {
    title: "Vérification d'identité",
    subtitle: "Pour finaliser votre enregistrement, nous devons vérifier votre identité",
    idDocument: "Pièce d'identité",
    idDocumentDesc: "Prenez une photo nette du recto de votre document (DNI, NIE, carte d'identité, passeport ou permis)",
    selfie: "Selfie",
    selfieDesc: "Prenez un selfie où votre visage est clairement visible",
    requirements: "Exigences :",
    req1: "Bon éclairage",
    req2: "Document entier dans le cadre",
    req3: "Texte lisible",
    req4: "Selfie sans accessoires masquant votre visage",
    start: "Démarrer la vérification",
    frontTitle: "Recto du document",
    alignDocument: "Alignez votre document dans le cadre",
    hintLegible: "Assurez-vous que toutes les informations sont lisibles",
    faceTitle: "Vérification du visage",
    alignFace: "Alignez votre visage dans le cercle",
    hintLookCamera: "Regardez droit vers la caméra, sans accessoires",
    reviewTitle: "Vérifiez vos photos",
    reviewSubtitle: "Vérifiez que toutes les images sont nettes et lisibles",
    frontDocTitle: "Recto du document",
    retake: "Reprendre",
    back: "Retour",
    submit: "Envoyer pour vérification",
    processingTitle: "Vérification de votre identité",
    processingDesc: "Nous validons vos documents. Cela peut prendre quelques secondes...",
    dontClose: "Ne fermez pas cette fenêtre",
    successTitle: "Vérification réussie !",
    successDesc: "Votre identité a été vérifiée avec succès.",
    continue: "Continuer",
    errorTitle: "Erreur de vérification",
    couldNotVerify: "Nous n'avons pas pu vérifier votre identité. Veuillez réessayer.",
    retry: "Réessayer",
    cameraErrorTitle: "Impossible d'accéder à la caméra",
    cameraErrorDesc: "Nous n'avons pas pu accéder à votre caméra. Veuillez vérifier les autorisations et réessayer.",
    suggestions: "Suggestions :",
    tip1: "Assurez-vous d'avoir accordé les autorisations de la caméra",
    tip2: "Vérifiez qu'aucune autre application n'utilise la caméra",
    tip3: "Redémarrez votre navigateur si le problème persiste",
    tryAgainCamera: "Réessayer",
    couldNotVerifyShort: "Nous n'avons pas pu vérifier votre identité",
    serverError: "Erreur du serveur",
    tryLater: "Veuillez réessayer plus tard",
  },
};
